module.exports = __webpack_public_path__ + "img/partner11.d242d2be.png";